import { useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import { auth } from "@/api/endpoints";
import { ChangePasswordDialog } from "@/components/shared/ChangePasswordDialog";

const NAV = [
  { to: "/inventory", label: "Inventory" },
  { to: "/revenue", label: "Revenue" },
  { to: "/contracts", label: "Contracts" },
  { to: "/renewals", label: "Renewals" },
  { to: "/idle", label: "Idle" },
  { to: "/admin", label: "Admin", roles: ["admin"] },
];

export function AppLayout() {
  const { user, clear } = useAuthStore();
  const nav = useNavigate();
  const [pwOpen, setPwOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await auth.logout();
    } finally {
      clear();
      nav("/login");
    }
  };

  return (
    <div className="min-h-full">
      <header className="border-b border-slate-200 bg-white dark:bg-slate-900 dark:border-slate-800">
        <div className="mx-auto max-w-7xl px-4 py-3 flex items-center justify-between gap-6">
          <div className="flex items-center gap-6">
            <div className="font-semibold tracking-tight">fleet-tracker</div>
            <nav className="flex items-center gap-4 text-sm">
              {NAV.filter((n) => !n.roles || (user && n.roles.includes(user.role))).map((n) => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  className={({ isActive }) =>
                    isActive
                      ? "text-brand-700 font-medium"
                      : "text-slate-600 hover:text-slate-900 dark:text-slate-300"
                  }
                >
                  {n.label}
                </NavLink>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3 text-sm">
            <div className="text-slate-500">
              {user?.username} <span className="text-xs">({user?.role})</span>
            </div>
            <button
              onClick={() => setPwOpen(true)}
              className="text-slate-500 hover:text-slate-900 underline-offset-2 hover:underline"
            >
              Change password
            </button>
            <button
              onClick={handleLogout}
              className="text-slate-500 hover:text-slate-900 underline-offset-2 hover:underline"
            >
              Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6">
        <Outlet />
      </main>
      {pwOpen && <ChangePasswordDialog onClose={() => setPwOpen(false)} />}
    </div>
  );
}
